import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {PdfDataService} from "./services/PdfData.service";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
PdfDataService.getPdfData().then((data) => {
    root.render(
        <React.StrictMode>
            <App {...data}/>
        </React.StrictMode>
    );
}).catch((err) => {
    root.render(
        <span>
            {err.toString()}
        </span>
    )
});
